import getConfig from "next/config"

export const isDevelopment = () => getConfig().publicRuntimeConfig.APP_ENV === "development"

export const isProduction = () => getConfig().publicRuntimeConfig.APP_ENV === "production"
